import React from "react";
import { Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar/Sidebar";
import Statistics from "../../components/Statistics/Statistics";
import "./Dashboard.css";
import { AuthContext } from "../../context/Authcontext";

export default function Dashboard() {
  const { user, loading } = React.useContext(AuthContext);

  if (loading) {
    return <div className="dashboard-container">Loading...</div>;
  }

  console.log("Dashboard user:", user);

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <h1>Admin Dashboard</h1>
        <p className="dashboard-intro">
          Manage content, review records and move quickly between sections from a single workspace.
        </p>
        <Statistics />
      </main>
    </div>
  );
}
